import axios from 'axios';
import { getUserFromSessionStorage } from './sessionStorage';

axios.interceptors.response.use((axiosResponse) => {
	if (axiosResponse?.config?.responseType === 'blob') {
		const contentDisposition = axiosResponse.headers.get('content-disposition');
		const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(contentDisposition);
		const filename =
			matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : 'download';

		return {
			blob: axiosResponse?.data,
			filename,
		};
	}
	return axiosResponse?.data;
});

axios.interceptors.request.use((config) => {
	const currentUser = getUserFromSessionStorage();
	if (currentUser) {
		const token = btoa(`${currentUser?.user?.username}:${currentUser?.user?.password}`);
		config.headers['Authorization'] = 'Basic ' + token;
	}
	if (!config.headers['Content-Type']) {
		config.headers['Content-Type'] = 'application/json';
	}

	return config;
});

export const GET = async ({ url, headers, responseType = null, baseURL = null }) =>
	await axios.get(url, { headers, responseType, baseURL });

export const DOWNLOAD = async ({ url, headers, responseType = null }) => {
	const response = await axios.get(url, { headers, responseType });

	// Create a blob URL from the blob data
	const { blob, filename } = response;

	// create file link in browser's memory
	const href = URL.createObjectURL(blob);

	// create "a" HTML element with href to file & click
	const link = document.createElement('a');
	link.href = href;
	link.setAttribute('download', filename); //or any other extension
	document.body.appendChild(link);
	link.click();

	// clean up "a" element & remove ObjectURL
	document.body.removeChild(link);
	URL.revokeObjectURL(href);
};

export const POST = async ({ url, headers, body }) => await axios.post(url, body, { headers });

export const PUT = async ({ url, headers, body }) => await axios.put(url, body, { headers });

export const FILE_UPLOAD = async ({ url, headers, body }) =>
	await axios.put(url, body, { headers });

export const DELETE = async ({ url, headers }) => await axios.delete(url, { headers });

export const PATCH = async ({ url, headers, body }) => await axios.patch(url, body, { headers });

export const responseStatusCode = {
	OK_STATUS: '200 OK',
	MULTI_STATUS: '207 MULTI_STATUS',
};
